import { useState } from "react";
import { Menu, X, CalendarCheck } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "react-router-dom";
import logo from "@/assets/logo-ib-2.png";
import LanguageSwitcher from "@/components/LanguageSwitcher";
import { useT, useLocalePath, useAnchorHref } from "@/i18n";

const Header = () => {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const lp = useLocalePath();
  const anchor = useAnchorHref();

  const navItems = useT(
    [
      { label: "Herzlich willkommen", href: "#willkommen", isAnchor: true },
      { label: "Mein fachlicher Ansatz", href: "#fachlicher-ansatz", isAnchor: true },
      { label: "Schwerpunkte", href: "#beschwerden", isAnchor: true },
      { label: "Über mich", href: "#ueber-mich", isAnchor: true },
      { label: "Magazin", href: "/blog", isAnchor: false },
      { label: "Veranstaltungen", href: "/veranstaltungen", isAnchor: false },
      { label: "Adventkalender", href: "/adventkalender", isAnchor: false },
      { label: "Mein Buch", href: "/e-book", isAnchor: false },
      { label: "Rezensionen", href: "#rezensionen", isAnchor: true },
      { label: "Termine und Preise", href: "#termine", isAnchor: true },
    ],
    [
      { label: "Welcome", href: "#willkommen", isAnchor: true },
      { label: "My professional approach", href: "#fachlicher-ansatz", isAnchor: true },
      { label: "Focus areas", href: "#beschwerden", isAnchor: true },
      { label: "About me", href: "#ueber-mich", isAnchor: true },
      { label: "Magazine", href: "/blog", isAnchor: false },
      { label: "Events", href: "/veranstaltungen", isAnchor: false },
      { label: "My book", href: "/e-book", isAnchor: false },
      { label: "Reviews", href: "#rezensionen", isAnchor: true },
      { label: "Appointments & fees", href: "#termine", isAnchor: true },
    ],
  );

  const bookLabel = useT("Termin", "Appointment");



  

  return (
    <header className="fixed top-0 left-0 right-0 z-50 bg-background/95 backdrop-blur-sm border-b border-border">
      <div className="container mx-auto px-4">
        <div className="flex items-center justify-between h-16 md:h-20">
          <Link to={lp("/")} className="flex items-center">
            <img src={logo} alt="Praxis Innere Balance" className="h-12 md:h-14 w-auto" />
          </Link>

          {/* Desktop Navigation */}
          <nav className="hidden lg:flex items-center gap-6">
            {navItems.map((item) => (
              item.isAnchor ? (
                <a
                  key={item.href}
                  href={anchor(item.href)}
                  className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors"
                >
                  {item.label}
                </a>
              ) : (
                <Link
                  key={item.href}
                  to={lp(item.href)}
                  className="text-sm font-medium text-muted-foreground hover:text-primary transition-colors relative inline-flex items-center gap-1.5"
                >
                  {item.label}
                </Link>
              )
            ))}
            <LanguageSwitcher />
            <Button asChild size="sm" className="gap-1.5">
              <Link to={lp("/termin")}>
                <CalendarCheck className="w-4 h-4" />
                {bookLabel}
              </Link>
            </Button>
          </nav>

          {/* Mobile: appointment + language + menu */}
          <div className="flex items-center gap-2 lg:hidden">
            <Button asChild size="sm" className="gap-1.5">
              <Link to={lp("/termin")}>
                <CalendarCheck className="w-4 h-4" />
                {bookLabel}
              </Link>
            </Button>
            <LanguageSwitcher />
            <button
              className="p-2"
              onClick={() => setIsMenuOpen(!isMenuOpen)}
              aria-label={useT("Menü öffnen", "Open menu")}
            >
              {isMenuOpen ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
            </button>
          </div>


        </div>

        {/* Mobile Navigation */}
        {isMenuOpen && (
          <nav className="lg:hidden py-4 pb-6 border-t border-border max-h-[calc(100vh-5rem)] overflow-y-auto">
            <div className="flex flex-col gap-1">
              {navItems.map((item) => (
                item.isAnchor ? (
                  <a
                    key={item.href}
                    href={anchor(item.href)}
                    className="text-base font-medium text-foreground hover:text-primary transition-colors py-2.5"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </a>
                ) : (
                  <Link
                    key={item.href}
                    to={lp(item.href)}
                    className="text-base font-medium text-foreground hover:text-primary transition-colors py-2.5 inline-flex items-center gap-1.5"
                    onClick={() => setIsMenuOpen(false)}
                  >
                    {item.label}
                  </Link>
                )
              ))}
            </div>


          </nav>
        )}
      </div>
    </header>
  );
};

export default Header;
